import { useState } from 'react';
import { heroSlides } from '../../data';
import './HeroSlider.css';

export default function HeroSlider({ setPage }) {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent(c => (c - 1 + heroSlides.length) % heroSlides.length);
  const next = () => setCurrent(c => (c + 1) % heroSlides.length);

  return (
    <div className="hero">
      {heroSlides.map((slide, i) => {
        const isActive = i === current;
        const TitleTag = isActive ? 'h1' : 'p';
        return (
          <div
            key={i}
            className={`hero__slide ${isActive ? 'hero__slide--active' : ''}`}
            style={slide.image ? { backgroundImage: `url(${slide.image})` } : undefined}
            aria-hidden={!isActive}
          >
            <div className="hero__inner">

              {/* Map / Pin Side */}
              <div className="hero__map-side">
                <div className="hero__tagline">{slide.tag}</div>
                <button
                  className="btn-primary hero__cta"
                  onClick={() => setPage('contact')}
                  tabIndex={isActive ? undefined : -1}
                >
                  Learn More
                </button>
              </div>

              {/* Text Content */}
              <div className="hero__content">
                <p className="hero__subtitle">{slide.subtitle}</p>
                <TitleTag className="hero__title">
                  {slide.title.split(slide.titleHighlight).map((part, pi, arr) => (
                    <span key={pi}>
                      {part}
                      {pi < arr.length - 1 && (
                        <span className="hero__title--red">{slide.titleHighlight}</span>
                      )}
                    </span>
                  ))}
                </TitleTag>
                <p className="hero__desc">{slide.desc}</p>
              </div>

            </div>
          </div>
        );
      })}

      {/* Controls */}
      <button className="hero__arrow hero__arrow--prev" onClick={prev} aria-label="Previous slide">‹</button>
      <button className="hero__arrow hero__arrow--next" onClick={next} aria-label="Next slide">›</button>

      <div className="hero__dots" role="tablist" aria-label="Hero slides">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            type="button"
            className={`hero__dot ${i === current ? 'hero__dot--active' : ''}`}
            onClick={() => setCurrent(i)}
            role="tab"
            aria-selected={i === current}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

